import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../constants/api';
import { useNotification } from '../../contexts/NotificationContext';
import { usePlan } from '../../contexts/PlanContext';
import Skeleton, { SKELETON_CSS } from '../shared/Skeleton';
import LockedFeature from '../shared/LockedFeature';
import BrandKitEditor from './BrandKitEditor';
import { useLanguage } from '../../contexts/LanguageContext';

const P = {
  blue:   '#0A0A0A',
  red:    '#DC2626',
  purple: '#525252',
  accentBg: 'rgba(10,10,10,0.06)',
  gray:   '#6B6B6B',
  dark:   '#0A0A0A',
  border: '#E5E5E5',
  bg:     '#f5f5f7',
};

const FONT = "'abcNormal','Inter','Arial',sans-serif";
const FONT_UI = "'Inter',system-ui,sans-serif";

const CSS = `
  @font-face {
    font-family: 'abcNormal';
    src: url('/fonts/ABCNormal_Normal.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  .tm-card{background:#fff;border-radius:18px;border:1px solid rgba(0,0,0,0.07);box-shadow:0 1px 3px rgba(0,0,0,0.05),0 1px 2px rgba(0,0,0,0.03);transition:box-shadow .22s ease,border-color .22s ease;}
  .tm-input{width:100%;padding:9px 13px;border:1px solid rgba(0,0,0,0.15);border-radius:10px;font-size:14px;font-family:${FONT_UI};color:#0A0A0A;background:#fff;outline:none;transition:border-color .15s,box-shadow .15s;letter-spacing:-.01em;box-sizing:border-box;}
  .tm-input:focus{border-color:#0A0A0A;box-shadow:0 0 0 3px rgba(10,10,10,0.08);}
  .tm-input::placeholder{color:#aeaeb2;}
  .tm-select{width:100%;padding:9px 13px;border:1px solid rgba(0,0,0,0.15);border-radius:10px;font-size:14px;font-family:${FONT_UI};color:#0A0A0A;background:#fff;outline:none;transition:border-color .15s,box-shadow .15s;letter-spacing:-.01em;box-sizing:border-box;}
  .tm-select:focus{border-color:#0A0A0A;box-shadow:0 0 0 3px rgba(10,10,10,0.08);}
  .tm-textarea{width:100%;padding:9px 13px;border:1px solid rgba(0,0,0,0.15);border-radius:10px;font-size:14px;font-family:${FONT_UI};color:#0A0A0A;background:#fff;outline:none;transition:border-color .15s,box-shadow .15s;letter-spacing:-.01em;box-sizing:border-box;resize:vertical;min-height:72px;}
  .tm-textarea:focus{border-color:#0A0A0A;box-shadow:0 0 0 3px rgba(10,10,10,0.08);}
  .tm-textarea::placeholder{color:#aeaeb2;}
  .tm-field-label{display:block;font-size:13px;font-weight:500;color:#0A0A0A;margin-bottom:6px;letter-spacing:-.01em;}
  .tm-btn{border:none;border-radius:980px;padding:8px 18px;font-size:13px;font-weight:500;cursor:pointer;font-family:${FONT_UI};letter-spacing:-.01em;transition:opacity .15s,background .15s;}
  .tm-btn-blue{background:#0A0A0A;color:#fff;}
  .tm-btn-blue:hover{opacity:.86;}
  .tm-btn-blue:disabled{opacity:.38;cursor:not-allowed;}
  .tm-btn-ghost{background:transparent;color:#0A0A0A;border:1px solid rgba(0,0,0,0.18);}
  .tm-btn-ghost:hover{background:rgba(0,0,0,0.04);}
  .tm-btn-sm{padding:5px 13px;font-size:12px;}
  .tm-btn-danger{background:rgba(220,38,38,0.08);color:#DC2626;border:1px solid rgba(220,38,38,0.2);}
  .tm-btn-danger:hover{background:rgba(220,38,38,0.13);}
  .tm-member-card{background:#fff;border-radius:16px;border:1px solid rgba(0,0,0,0.07);overflow:hidden;transition:box-shadow .25s ease,border-color .25s ease,transform .25s cubic-bezier(.22,1,.36,1);position:relative;}
  .tm-member-card:hover{box-shadow:0 10px 28px rgba(0,0,0,0.09);border-color:rgba(0,0,0,0.12);transform:translateY(-3px);}
  .tm-member-accent{height:3px;width:100%;}
  .tm-stat-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:14px;margin-bottom:24px;}
  .tm-stat-card{background:#fff;border:1px solid #E5E5E5;border-radius:12px;padding:16px 18px;box-shadow:0 1px 2px rgba(0,0,0,0.04);transition:box-shadow .2s ease,border-color .2s ease,transform .2s cubic-bezier(.22,1,.36,1);}
  .tm-stat-card:hover{box-shadow:0 4px 16px rgba(0,0,0,0.08);border-color:#D4D4D4;transform:translateY(-2px);}
  .tm-stat-icon{width:34px;height:34px;border-radius:9px;display:flex;align-items:center;justify-content:center;margin-bottom:12px;}
  .tm-stat-value{font-size:26px;font-weight:700;color:#0A0A0A;letter-spacing:-0.02em;line-height:1;font-family:${FONT_UI};}
  .tm-stat-label{font-size:12.5px;color:#6B6B6B;font-weight:500;margin-top:5px;letter-spacing:-0.005em;font-family:${FONT_UI};}
  @keyframes tm-modalIn{from{opacity:0;transform:scale(.96) translateY(8px)}to{opacity:1;transform:scale(1) translateY(0)}}
  .tm-modal{animation:tm-modalIn .28s cubic-bezier(.22,1,.36,1) both;}
  .tm-seg{display:flex;background:rgba(0,0,0,0.055);border-radius:8px;padding:2px;gap:2px;}
  .tm-seg-btn{border:none;border-radius:6px;padding:3px 10px;font-size:11px;font-weight:500;cursor:pointer;transition:background .15s,color .15s,box-shadow .15s;font-family:${FONT_UI};letter-spacing:-.01em;}
  .tm-seg-btn.on{background:#fff;color:#0A0A0A;box-shadow:0 1px 3px rgba(0,0,0,0.12);}
  .tm-seg-btn:not(.on){background:transparent;color:#6B6B6B;}
  .tm-expand-btn{width:100%;background:transparent;border:none;border-top:1px solid rgba(0,0,0,0.06);padding:10px 16px;display:flex;align-items:center;justify-content:center;gap:6px;font-size:12px;font-weight:500;color:#6B6B6B;cursor:pointer;font-family:${FONT_UI};letter-spacing:-.01em;transition:background .15s,color .15s;}
  .tm-expand-btn:hover{background:rgba(0,0,0,0.025);color:#0A0A0A;}
  .tm-chevron{transition:transform .22s ease;}
  .tm-chevron.open{transform:rotate(180deg);}
  .tm-history-dot{width:6px;height:6px;border-radius:50%;background:#0A0A0A;flex-shrink:0;margin-top:4px;}
  @keyframes tm-fadeup{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}
  .tm-enter{animation:tm-fadeup .24s cubic-bezier(.25,.46,.45,.94) both;}
  .tm-modal-backdrop{position:fixed;inset:0;background:rgba(0,0,0,0.35);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;z-index:50;padding:20px;}
  .tm-modal{background:#fff;border-radius:20px;box-shadow:0 24px 60px rgba(0,0,0,0.18);max-width:460px;width:100%;overflow:hidden;}
  .tm-key-box{background:#f5f5f7;border-radius:12px;padding:16px 18px;font-family:'SF Mono',ui-monospace,'Cascadia Code',monospace;font-size:15px;color:#0A0A0A;word-break:break-all;letter-spacing:.03em;line-height:1.5;border:1px solid rgba(0,0,0,0.07);}
  .tm-warning{background:rgba(217,119,6,0.08);border:1px solid rgba(217,119,6,0.22);border-radius:10px;padding:12px 14px;}
  .tm-search-wrap{position:relative;}
  .tm-search-wrap svg{position:absolute;left:11px;top:50%;transform:translateY(-50%);pointer-events:none;}
  .tm-search-wrap input{padding-left:34px !important;}

  /* Hero (company logo) */
  .tm-hero{display:flex;align-items:center;gap:16px;padding:18px 22px;border-radius:16px;background:#FAFAFA;border:1px solid rgba(0,0,0,0.08);margin-bottom:20px;}
  .tm-hero-logo{width:52px;height:52px;border-radius:13px;background:#fff;border:1px solid rgba(0,0,0,0.1);display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0;}
  .tm-hero-logo img{width:100%;height:100%;object-fit:contain;}
  .tm-hero-logo-fallback{font-size:18px;font-weight:700;color:#0A0A0A;}
  .tm-hero-name{font-size:16px;font-weight:700;color:#0A0A0A;letter-spacing:-0.02em;}
  .tm-hero-industry{font-size:12.5px;color:#6B6B6B;margin-top:2px;letter-spacing:-0.01em;}

  /* Inline edit (name/position) */
  .tm-edit-btn{background:transparent;border:none;cursor:pointer;color:#9A9A9A;padding:4px;border-radius:6px;flex-shrink:0;display:flex;align-items:center;transition:background .15s,color .15s;}
  .tm-edit-btn:hover{background:rgba(0,0,0,0.05);color:#0A0A0A;}
  .tm-edit-input{width:100%;border:1px solid rgba(0,0,0,0.18);border-radius:7px;padding:4px 7px;font-size:13px;font-family:${FONT_UI};color:#0A0A0A;outline:none;box-sizing:border-box;margin-bottom:4px;}
  .tm-edit-input:focus{border-color:#0A0A0A;box-shadow:0 0 0 3px rgba(10,10,10,0.08);}
  .tm-edit-actions{display:flex;gap:6px;margin-top:6px;}

  /* Invite by email */
  .tm-invite-row{display:flex;gap:6px;margin-top:6px;}
  .tm-invite-input{flex:1;border:1px solid rgba(0,0,0,0.15);border-radius:8px;padding:6px 10px;font-size:12.5px;font-family:${FONT_UI};color:#0A0A0A;outline:none;box-sizing:border-box;}
  .tm-invite-input:focus{border-color:#0A0A0A;box-shadow:0 0 0 3px rgba(10,10,10,0.08);}
  .tm-invited-pill{font-size:11px;color:#6B6B6B;margin-top:6px;letter-spacing:-0.01em;}

  /* Audit log */
  .tm-audit-row{display:flex;gap:10px;align-items:flex-start;padding:11px 0;border-bottom:1px solid rgba(0,0,0,0.055);}
  .tm-audit-row:last-child{border-bottom:none;}
  .tm-audit-dot{width:7px;height:7px;border-radius:50%;background:#0A0A0A;flex-shrink:0;margin-top:5px;}
  .tm-audit-desc{font-size:13px;color:#0A0A0A;margin:0;letter-spacing:-0.01em;line-height:1.4;}
  .tm-audit-time{font-size:11.5px;color:#9A9A9A;margin:2px 0 0;}

  @media (max-width: 768px) {
    .tm-card{border-radius:12px;padding:13px 14px !important;}
    .tm-member-card{border-radius:11px;}
    .tm-input,.tm-select,.tm-textarea{padding:6px 9px;font-size:12px;}
    .tm-textarea{min-height:50px;}
    .tm-field-label{font-size:10.5px;margin-bottom:4px;}
    .tm-btn{padding:6px 11px;font-size:11px;min-height:34px;}
    .tm-btn-sm{padding:4px 9px;font-size:10.5px;min-height:34px;}
    .tm-seg-btn{padding:2px 6px;font-size:10.5px;}
    .tm-expand-btn{padding:6px 10px;font-size:10.5px;gap:4px;}
    .tm-history-dot{width:4px;height:4px;margin-top:3px;}
    .tm-modal{border-radius:13px;}
    .tm-key-box{padding:10px 11px;font-size:11.5px;}
    .tm-warning{padding:7px 9px;border-radius:7px;}
    .tm-avatar{width:38px !important;height:38px !important;border-radius:11px !important;}
    .tm-avatar-letter{font-size:15px !important;}
    .tm-stat-grid{grid-template-columns:repeat(2,1fr);gap:9px;margin-bottom:20px;}
    .tm-stat-card{padding:12px 13px;}
    .tm-stat-icon{width:28px;height:28px;border-radius:7px;margin-bottom:8px;}
    .tm-stat-value{font-size:19px;}
    .tm-stat-label{font-size:10.5px;margin-top:3px;}
  }
`;

const IconSearch = () => (
  <svg width="15" height="15" fill="none" stroke={P.gray} strokeWidth="2" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8"/><path strokeLinecap="round" d="M21 21l-4.35-4.35"/>
  </svg>
);
const IconChevron = ({ open }) => (
  <svg className={`tm-chevron${open ? ' open' : ''}`} width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"/>
  </svg>
);
const IconKey = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <circle cx="8" cy="15" r="4"/><path strokeLinecap="round" d="M12 11l8-8m0 0v4m0-4h-4"/>
  </svg>
);
const IconRefresh = () => (
  <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
  </svg>
);
const IconCopy = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
  </svg>
);
const IconPeople = () => (
  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
  </svg>
);
const IconClock = () => (
  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9"/><path strokeLinecap="round" d="M12 7v5l3 3"/>
  </svg>
);
const IconGaugeSm = () => (
  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path strokeLinecap="round" d="M12 20a8 8 0 10-8-8"/><path strokeLinecap="round" d="M12 12l4-4"/>
  </svg>
);
const IconPencil = () => (
  <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
    <path strokeLinecap="round" strokeLinejoin="round" d="M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
const IconMail = () => (
  <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <rect x="2" y="4" width="20" height="16" rx="2"/><path strokeLinecap="round" strokeLinejoin="round" d="M22 6l-10 7L2 6"/>
  </svg>
);
const IconLock = ({ open }) => (
  <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    {open
      ? <><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 019.9-1"/></>
      : <><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></>
    }
  </svg>
);

const TeamsPanel = ({ user, profiles }) => {
  const { toast, confirm } = useNotification();
  const { hasFeature } = usePlan();
  const { t } = useLanguage();
  // Internal sub-view, not a sidebar tab — keeps "Marca" reachable from
  // Teams without adding another top-level sidebar item.
  const [view, setView] = useState('members');
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [teamName, setTeamName] = useState('');
  const [industry, setIndustry] = useState('');
  const [companyDescription, setCompanyDescription] = useState('');
  const [companyInfoComplete, setCompanyInfoComplete] = useState(null);
  const [savingCompanyInfo, setSavingCompanyInfo] = useState(false);
  const [companyInfoError, setCompanyInfoError] = useState('');
  const [showKeyModal, setShowKeyModal] = useState(false);
  const [currentKey, setCurrentKey] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedMember, setExpandedMember] = useState(null);
  const [memberHistory, setMemberHistory] = useState({});
  const [historyDaysFilter, setHistoryDaysFilter] = useState(7);
  const [loadingHistory, setLoadingHistory] = useState({});
  const [copied, setCopied] = useState(false);
  const [industryOptions, setIndustryOptions] = useState([]);
  const [brandLogoUrl, setBrandLogoUrl] = useState(null);
  const [auditLog, setAuditLog] = useState([]);
  const [loadingAudit, setLoadingAudit] = useState(false);
  const [editingMember, setEditingMember] = useState(null);
  const [editDraft, setEditDraft] = useState({ name: '', position: '' });
  const [savingEdit, setSavingEdit] = useState(false);
  const [inviteDrafts, setInviteDrafts] = useState({});
  const [invitingMember, setInvitingMember] = useState(null);

  const getToken = () => localStorage.getItem('token');

  useEffect(() => {
    loadMembers();
    loadTeamSettings();
    loadIndustryOptions();
    loadBrandLogo();
  }, []);

  const loadBrandLogo = async () => {
    try {
      const response = await axios.get(`${API}/teams/brand-kit`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setBrandLogoUrl(response.data?.brand_kit?.company_logo_url || null);
    } catch (error) {
      // brand_kit may not be enabled on this plan — hero simply stays hidden
    }
  };

  const loadAuditLog = async () => {
    try {
      setLoadingAudit(true);
      const response = await axios.get(`${API}/teams/audit-log`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setAuditLog(response.data?.entries || []);
    } catch (error) {
      console.error('Error loading audit log:', error);
    } finally {
      setLoadingAudit(false);
    }
  };

  const loadMembers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/teams/members`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setMembers(response.data.members || response.data);
    } catch (error) {
      console.error('Error loading members:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadMemberHistory = async (profileId, days = 7) => {
    try {
      setLoadingHistory(prev => ({ ...prev, [profileId]: true }));
      const response = await axios.get(`${API}/teams/members/${profileId}/history?days=${days}`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setMemberHistory(prev => ({ ...prev, [profileId]: response.data.history }));
    } catch (error) {
      console.error('Error loading history:', error);
    } finally {
      setLoadingHistory(prev => ({ ...prev, [profileId]: false }));
    }
  };

  const loadTeamSettings = async () => {
    try {
      const response = await axios.get(`${API}/teams/settings`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setTeamName(response.data.team_name || '');
      setIndustry(response.data.industry || '');
      setCompanyDescription(response.data.company_description || '');
      setCompanyInfoComplete(!!response.data.company_info_complete);
    } catch (error) {
      console.error('Error loading team settings:', error);
    }
  };

  const loadIndustryOptions = async () => {
    try {
      const response = await axios.get(`${API}/teams/industry-options`, {
        headers: { Authorization: `Bearer ${getToken()}` }
      });
      setIndustryOptions(response.data.options || []);
    } catch (error) {
      console.error('Error loading industry options:', error);
    }
  };

  const handleGenerateKey = async (profileId) => {
    try {
      const response = await axios.post(
        `${API}/teams/access-keys/${profileId}/generate`,
        {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      setCurrentKey(response.data);
      setShowKeyModal(true);
      loadMembers();
    } catch (error) {
      toast.error(error.response?.data?.detail || t('teams.toast.genKeyError', 'Error generando llave de acceso'));
    }
  };

  const handleRegenerateKey = async (profileId) => {
    if (!(await confirm(t('teams.confirm.regenerate', '¿Estás seguro? La llave anterior dejará de funcionar inmediatamente.'), { confirmLabel: t('teams.confirm.regenerateLabel', 'Regenerar') }))) return;
    try {
      const response = await axios.post(
        `${API}/teams/access-keys/${profileId}/regenerate`,
        {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      setCurrentKey(response.data);
      setShowKeyModal(true);
      loadMembers();
    } catch (error) {
      toast.error(error.response?.data?.detail || t('teams.toast.regenKeyError', 'Error regenerando llave'));
    }
  };

  const handleToggleKey = async (profileId, isCurrentlyActive, memberName) => {
    // Deactivating cuts that member's access immediately — confirm it like
    // any other destructive action. Reactivating is harmless, no prompt needed.
    if (isCurrentlyActive) {
      const ok = await confirm(
        t('teams.confirm.deactivate', `¿Desactivar el acceso de ${memberName || 'este miembro'}? No podrá iniciar sesión hasta que reactives su llave.`).replace('{name}', memberName || t('teams.thisMember', 'este miembro')),
        { confirmLabel: t('teams.confirm.deactivateLabel', 'Desactivar acceso'), danger: true }
      );
      if (!ok) return;
    }
    try {
      await axios.post(
        `${API}/teams/access-keys/${profileId}/toggle`,
        {},
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      loadMembers();
    } catch (error) {
      toast.error(error.response?.data?.detail || t('teams.toast.toggleError', 'Error cambiando estado'));
    }
  };

  const toggleMemberExpanded = (memberId) => {
    if (expandedMember === memberId) {
      setExpandedMember(null);
    } else {
      setExpandedMember(memberId);
      if (!memberHistory[memberId]) {
        loadMemberHistory(memberId, historyDaysFilter);
      }
    }
  };

  const handleHistoryFilterChange = (memberId, days) => {
    setHistoryDaysFilter(days);
    loadMemberHistory(memberId, days);
  };

  const handleSaveCompanyInfo = async () => {
    if (!teamName.trim() || !industry) {
      setCompanyInfoError(t('teams.companyInfo.error', 'Completa el nombre de la empresa y el rubro para continuar.'));
      return;
    }
    setCompanyInfoError('');
    setSavingCompanyInfo(true);
    try {
      await axios.put(
        `${API}/teams/settings`,
        {
          team_name: teamName.trim(),
          industry,
          company_description: companyDescription.trim() || null,
        },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      setCompanyInfoComplete(true);
    } catch (error) {
      toast.error(t('teams.toast.saveCompanyError', 'Error guardando los datos de la empresa'));
    } finally {
      setSavingCompanyInfo(false);
    }
  };

  const handleCopyKey = () => {
    navigator.clipboard.writeText(currentKey.access_key);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const startEditMember = (member) => {
    setEditingMember(member.id);
    setEditDraft({ name: member.name || '', position: member.position || '' });
  };

  const cancelEditMember = () => {
    setEditingMember(null);
  };

  const saveEditMember = async (profileId) => {
    if (!editDraft.name.trim()) {
      toast.error(t('teams.edit.nameRequired', 'El nombre no puede quedar vacío'));
      return;
    }
    setSavingEdit(true);
    try {
      await axios.put(
        `${API}/teams/members/${profileId}`,
        { name: editDraft.name.trim(), position: editDraft.position.trim() || null },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      setMembers(prev => prev.map(m => m.id === profileId ? { ...m, name: editDraft.name.trim(), position: editDraft.position.trim() } : m));
      setEditingMember(null);
      toast.success(t('teams.edit.saved', 'Miembro actualizado'));
    } catch (error) {
      toast.error(error.response?.data?.detail || t('teams.edit.error', 'No se pudo guardar'));
    } finally {
      setSavingEdit(false);
    }
  };

  const handleInviteMember = async (profileId) => {
    const email = (inviteDrafts[profileId] || '').trim();
    if (!email || !email.includes('@')) {
      toast.error(t('teams.invite.invalidEmail', 'Ingresa un correo válido'));
      return;
    }
    setInvitingMember(profileId);
    try {
      const response = await axios.post(
        `${API}/teams/access-keys/${profileId}/invite`,
        { email },
        { headers: { Authorization: `Bearer ${getToken()}` } }
      );
      toast.success(response.data?.email_sent
        ? t('teams.invite.sent', 'Invitación enviada por correo')
        : t('teams.invite.sentNoEmail', 'Llave generada, pero no se pudo enviar el correo'));
      setInviteDrafts(prev => ({ ...prev, [profileId]: '' }));
      loadMembers();
    } catch (error) {
      toast.error(error.response?.data?.detail || t('teams.invite.error', 'No se pudo enviar la invitación'));
    } finally {
      setInvitingMember(null);
    }
  };

  const timeAgo = (iso) => {
    if (!iso) return '';
    const date = new Date(iso);
    const diffMs = Date.now() - date.getTime();
    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 1) return t('teams.audit.now', 'hace un momento');
    if (minutes < 60) return t('teams.audit.minutesAgo', `hace ${minutes} min`).replace('{n}', minutes);
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return t('teams.audit.hoursAgo', `hace ${hours}h`).replace('{n}', hours);
    const days = Math.floor(hours / 24);
    return t('teams.audit.daysAgo', `hace ${days}d`).replace('{n}', days);
  };

  const filteredMembers = members.filter(member =>
    member.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (member.position && member.position.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const activeKeys = members.filter(m => m.has_access_key && m.access_key_active).length;
  const withoutKey = members.filter(m => !m.has_access_key).length;
  const activeRate = members.length > 0 ? Math.round((activeKeys / members.length) * 100) : 0;

  if (companyInfoComplete === null) {
    return (
      <div style={{maxWidth:'100%',width:'100%'}}>
        <style>{CSS}</style>
        <style>{SKELETON_CSS}</style>
        <div style={{marginBottom:28,paddingBottom:20,borderBottom:'1px solid rgba(0,0,0,0.06)'}}>
          <Skeleton width={90} height={26} style={{marginBottom:8}} />
          <Skeleton width={220} height={13} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {[1,2,3].map((i) => (
            <div key={i} className="tm-member-card" style={{padding:16}}>
              <div style={{display:'flex',alignItems:'center',gap:12}}>
                <Skeleton width={46} height={46} radius={14} />
                <div style={{flex:1}}>
                  <Skeleton width="70%" height={13} style={{marginBottom:6}} />
                  <Skeleton width="45%" height={11} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!companyInfoComplete) {
    return (
      <div style={{maxWidth:'100%',width:'100%'}}>
        <style>{CSS}</style>
        <div style={{marginBottom:28,paddingBottom:20,borderBottom:'1px solid rgba(0,0,0,0.06)'}}>
          <h1 style={{fontSize:28,fontWeight:300,color:P.dark,letterSpacing:'-0.01em',margin:0,fontFamily:FONT,lineHeight:1.1}}>
            Teams
          </h1>
          <p style={{fontSize:13,color:P.gray,marginTop:5,letterSpacing:'-0.01em',margin:'5px 0 0'}}>
            {t('teams.onboarding.subtitle', 'Antes de gestionar tu equipo, cuéntanos sobre tu empresa')}
          </p>
        </div>

        <div className="tm-card tm-enter" style={{padding:'24px',maxWidth:480}}>
          <h2 style={{fontSize:15,fontWeight:600,color:P.dark,letterSpacing:'-0.02em',margin:'0 0 4px'}}>{t('teams.companyInfo.title', 'Datos de tu empresa')}</h2>
          <p style={{fontSize:12,color:P.gray,margin:'0 0 20px',letterSpacing:'-0.01em'}}>
            {t('teams.companyInfo.desc', 'Esta información nos ayuda a conocer mejor a las empresas que usan Contact.')}
          </p>

          <div style={{marginBottom:16}}>
            <label className="tm-field-label">{t('teams.companyInfo.name', 'Nombre de la empresa')}</label>
            <input
              className="tm-input"
              type="text"
              value={teamName}
              onChange={e => setTeamName(e.target.value)}
              placeholder={t('teams.companyInfo.namePlaceholder', 'Ej: Acme Corporation')}
            />
          </div>

          <div style={{marginBottom:16}}>
            <label className="tm-field-label">{t('teams.companyInfo.industry', 'Rubro')}</label>
            <select
              className="tm-select"
              value={industry}
              onChange={e => setIndustry(e.target.value)}
            >
              <option value="">{t('teams.companyInfo.industryPlaceholder', 'Selecciona un rubro…')}</option>
              {industryOptions.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </div>

          <div style={{marginBottom:20}}>
            <label className="tm-field-label">{t('teams.companyInfo.description', 'Descripción')} <span style={{color:P.gray,fontWeight:400}}>({t('teams.optional', 'opcional')})</span></label>
            <textarea
              className="tm-textarea"
              value={companyDescription}
              onChange={e => setCompanyDescription(e.target.value)}
              placeholder={t('teams.companyInfo.descPlaceholder', 'Breve descripción de tu empresa')}
            />
          </div>

          {companyInfoError && (
            <p style={{fontSize:12,color:P.red,margin:'0 0 14px',letterSpacing:'-0.01em'}}>{companyInfoError}</p>
          )}

          <button
            className="tm-btn tm-btn-blue"
            style={{width:'100%',padding:'11px 18px',fontSize:14}}
            onClick={handleSaveCompanyInfo}
            disabled={savingCompanyInfo}
          >
            {savingCompanyInfo ? t('teams.companyInfo.saving', 'Guardando…') : t('teams.companyInfo.saveAndContinue', 'Guardar y continuar')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{maxWidth:'100%',width:'100%'}}>
      <style>{CSS}</style>

      {/* ── Header ──────────────────────────────────────────────── */}
      <div style={{marginBottom:24,paddingBottom:20,borderBottom:'1px solid rgba(0,0,0,0.06)'}}>
        <h1 style={{fontSize:28,fontWeight:300,color:P.dark,letterSpacing:'-0.01em',margin:0,fontFamily:FONT,lineHeight:1.1}}>
          Teams
        </h1>
        <p style={{fontSize:13,color:P.gray,marginTop:5,letterSpacing:'-0.01em',margin:'5px 0 0'}}>
          {t('teams.subtitle', 'Gestiona tu equipo y el acceso corporativo')}
        </p>
      </div>

      {/* ── Sub-view switcher (Miembros / Marca / Historial) ───────── */}
      <div className="tm-seg" style={{width:'fit-content',marginBottom:20}}>
        <button className={`tm-seg-btn ${view === 'members' ? 'on' : ''}`} onClick={() => setView('members')}>
          {t('teams.tabs.members', 'Miembros')}
        </button>
        <button className={`tm-seg-btn ${view === 'brand' ? 'on' : ''}`} onClick={() => setView('brand')}>
          {t('teams.tabs.brand', 'Marca')}
        </button>
        <button className={`tm-seg-btn ${view === 'history' ? 'on' : ''}`} onClick={() => { setView('history'); if (auditLog.length === 0) loadAuditLog(); }}>
          {t('teams.tabs.history', 'Historial')}
        </button>
      </div>

      {view === 'brand' ? (
        <LockedFeature feature="brand_kit">
          <BrandKitEditor />
        </LockedFeature>
      ) : view === 'history' ? (
        <div className="tm-card" style={{padding:'20px 24px'}}>
          <h2 style={{fontSize:15,fontWeight:600,color:P.dark,letterSpacing:'-0.02em',margin:'0 0 14px'}}>
            {t('teams.audit.title', 'Historial de acciones')}
          </h2>
          {loadingAudit ? (
            <div style={{display:'flex',justifyContent:'center',padding:'24px 0'}}>
              <div style={{width:20,height:20,borderRadius:'50%',border:'2px solid rgba(0,0,0,0.08)',borderTopColor:P.blue,animation:'tm-spin .75s linear infinite'}}/>
            </div>
          ) : auditLog.length === 0 ? (
            <p style={{fontSize:13,color:P.gray,textAlign:'center',padding:'24px 0',margin:0}}>
              {t('teams.audit.empty', 'Sin acciones registradas aún')}
            </p>
          ) : (
            <div>
              {auditLog.map(entry => (
                <div key={entry.id} className="tm-audit-row">
                  <div className="tm-audit-dot"/>
                  <div style={{flex:1}}>
                    <p className="tm-audit-desc">{entry.description}</p>
                    <p className="tm-audit-time">{timeAgo(entry.timestamp)}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
      <>
      {/* ── Hero: company logo ──────────────────────────────────── */}
      {brandLogoUrl && (
        <div className="tm-hero">
          <div className="tm-hero-logo"><img src={brandLogoUrl} alt={teamName || 'Logo'} /></div>
          <div>
            <div className="tm-hero-name">{teamName}</div>
            {industry && <div className="tm-hero-industry">{industry}</div>}
          </div>
        </div>
      )}

      {/* ── Stats ───────────────────────────────────────────────── */}
      <div className="tm-stat-grid">
        <div className="tm-stat-card">
          <div className="tm-stat-icon" style={{background:P.accentBg,color:P.blue}}>
            <IconPeople />
          </div>
          <div className="tm-stat-value">{members.length}</div>
          <div className="tm-stat-label">{t('teams.stats.totalMembers', 'Miembros totales')}</div>
        </div>
        <div className="tm-stat-card">
          <div className="tm-stat-icon" style={{background:P.accentBg,color:P.blue}}>
            <IconKey />
          </div>
          <div className="tm-stat-value">{activeKeys}</div>
          <div className="tm-stat-label">{t('teams.stats.activeKeys', 'Llaves activas')}</div>
        </div>
        <div className="tm-stat-card">
          <div className="tm-stat-icon" style={{background:P.accentBg,color:P.blue}}>
            <IconClock />
          </div>
          <div className="tm-stat-value">{withoutKey}</div>
          <div className="tm-stat-label">{t('teams.stats.noKey', 'Sin llave asignada')}</div>
        </div>
        <div className="tm-stat-card">
          <div className="tm-stat-icon" style={{background:P.accentBg,color:P.blue}}>
            <IconGaugeSm />
          </div>
          <div className="tm-stat-value">{activeRate}%</div>
          <div className="tm-stat-label">{t('teams.stats.activeRate', 'Equipo con acceso activo')}</div>
        </div>
      </div>

      {/* ── Members ─────────────────────────────────────────────── */}
      <div className="tm-card" style={{padding:'20px 24px'}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16,flexWrap:'wrap',gap:10}}>
          <h2 style={{fontSize:15,fontWeight:600,color:P.dark,letterSpacing:'-0.02em',margin:0}}>
            {t('teams.members.title', 'Miembros del Equipo')}
          </h2>
          <div className="tm-search-wrap" style={{width:220}}>
            <IconSearch />
            <input
              className="tm-input"
              type="text"
              placeholder={t('teams.members.searchPlaceholder', 'Buscar…')}
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              style={{padding:'7px 12px 7px 34px',fontSize:13}}
            />
          </div>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            <style>{SKELETON_CSS}</style>
            {[1,2,3,4,5,6].map((i) => (
              <div key={i} className="tm-member-card" style={{padding:16}}>
                <div style={{display:'flex',alignItems:'center',gap:12}}>
                  <Skeleton width={46} height={46} radius={14} />
                  <div style={{flex:1}}>
                    <Skeleton width="70%" height={13} style={{marginBottom:6}} />
                    <Skeleton width="45%" height={11} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : filteredMembers.length === 0 ? (
          <div style={{textAlign:'center',padding:'48px 0'}}>
            <div style={{width:48,height:48,borderRadius:'50%',background:'rgba(0,0,0,0.04)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 12px'}}>
              <svg width="22" height="22" fill="none" stroke={P.gray} strokeWidth="1.5" viewBox="0 0 24 24">
                <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
              </svg>
            </div>
            <p style={{fontSize:14,fontWeight:500,color:P.dark,margin:'0 0 4px'}}>
              {searchQuery ? t('teams.members.noResults', 'Sin resultados') : t('teams.members.noneYet', 'Sin miembros aún')}
            </p>
            <p style={{fontSize:12,color:P.gray,margin:0}}>
              {searchQuery ? t('teams.members.noMatches', `No hay coincidencias para "${searchQuery}"`).replace('{query}', searchQuery) : t('teams.members.emptyDesc', 'Agrega perfiles a tu equipo para verlos aquí')}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {filteredMembers.map((member, i) => (
              <div key={member.id} className="tm-member-card tm-enter" style={{animationDelay:`${i*0.04}s`}}>

                {/* Status accent */}
                <div
                  className="tm-member-accent"
                  style={{background: member.access_key_active ? P.blue : member.has_access_key ? P.gray : 'rgba(0,0,0,0.08)'}}
                />

                {/* Card Body */}
                <div style={{padding:'16px 16px 0'}}>
                  <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:12}}>
                    {/* Avatar */}
                    <div className="tm-avatar" style={{
                      width:46,height:46,borderRadius:14,flexShrink:0,overflow:'hidden',
                      background:`linear-gradient(135deg,${P.blue}cc,${P.purple}cc)`,
                      display:'flex',alignItems:'center',justifyContent:'center',
                    }}>
                      {member.profile_image_url ? (
                        <img src={member.profile_image_url} alt={member.name} style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                      ) : (
                        <span className="tm-avatar-letter" style={{fontSize:18,fontWeight:700,color:'#fff',letterSpacing:'-0.02em'}}>
                          {member.name.charAt(0).toUpperCase()}
                        </span>
                      )}
                    </div>

                    {/* Info */}
                    {editingMember === member.id ? (
                      <div style={{flex:1,minWidth:0}} onClick={e => e.stopPropagation()}>
                        <input
                          className="tm-edit-input"
                          value={editDraft.name}
                          onChange={e => setEditDraft(prev => ({ ...prev, name: e.target.value }))}
                          placeholder={t('teams.edit.namePlaceholder', 'Nombre')}
                          autoFocus
                        />
                        <input
                          className="tm-edit-input"
                          style={{marginBottom:0}}
                          value={editDraft.position}
                          onChange={e => setEditDraft(prev => ({ ...prev, position: e.target.value }))}
                          placeholder={t('teams.edit.positionPlaceholder', 'Cargo')}
                        />
                        <div className="tm-edit-actions">
                          <button className="tm-btn tm-btn-blue tm-btn-sm" style={{flex:1}} disabled={savingEdit} onClick={() => saveEditMember(member.id)}>
                            {savingEdit ? t('teams.edit.saving', 'Guardando…') : t('teams.edit.save', 'Guardar')}
                          </button>
                          <button className="tm-btn tm-btn-ghost tm-btn-sm" style={{flex:1}} disabled={savingEdit} onClick={cancelEditMember}>
                            {t('teams.edit.cancel', 'Cancelar')}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:14,fontWeight:600,color:P.dark,letterSpacing:'-0.015em',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                          {member.name}
                        </div>
                        <div style={{fontSize:12,color:P.gray,letterSpacing:'-0.01em',marginTop:1,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                          {member.position || t('teams.members.noRole', 'Sin cargo')}
                        </div>
                      </div>
                    )}

                    {/* Edit button */}
                    {editingMember !== member.id && (
                      <button className="tm-edit-btn" onClick={(e) => { e.stopPropagation(); startEditMember(member); }} title={t('teams.edit.title', 'Editar nombre o cargo')}>
                        <IconPencil />
                      </button>
                    )}

                    {/* Key status pill */}
                    {member.has_access_key && editingMember !== member.id && (
                      <span style={{
                        display:'inline-flex',alignItems:'center',gap:4,flexShrink:0,
                        fontSize:10.5,fontWeight:600,padding:'3px 8px',borderRadius:980,
                        background: member.access_key_active ? P.accentBg : 'rgba(0,0,0,0.05)',
                        color: member.access_key_active ? P.blue : P.gray,
                      }}>
                        <IconLock open={member.access_key_active} />
                        {member.access_key_active ? t('teams.members.active', 'Activa') : t('teams.members.inactive', 'Inactiva')}
                      </span>
                    )}
                  </div>
                </div>

                {/* Expand toggle */}
                <button className="tm-expand-btn" onClick={() => toggleMemberExpanded(member.id)}>
                  <IconChevron open={expandedMember === member.id} />
                  <span>{expandedMember === member.id ? t('teams.members.hideDetails', 'Ocultar detalles') : t('teams.members.viewDetails', 'Ver detalles')}</span>
                </button>

                {/* Expanded content */}
                {expandedMember === member.id && (
                  <div style={{borderTop:'1px solid rgba(0,0,0,0.06)',background:P.bg,padding:'14px 16px'}}>

                    {/* Activity */}
                    <div style={{marginBottom:14}}>
                      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10}}>
                        <span style={{fontSize:12,fontWeight:600,color:P.dark,letterSpacing:'-0.01em'}}>{t('teams.activity.title', 'Actividad reciente')}</span>
                        <div className="tm-seg">
                          {[7,30].map(d => (
                            <button
                              key={d}
                              className={`tm-seg-btn${historyDaysFilter === d ? ' on' : ''}`}
                              onClick={() => handleHistoryFilterChange(member.id, d)}
                            >
                              {d}d
                            </button>
                          ))}
                        </div>
                      </div>

                      {loadingHistory[member.id] ? (
                        <div style={{display:'flex',justifyContent:'center',padding:'16px 0'}}>
                          <div style={{width:18,height:18,borderRadius:'50%',border:`2px solid rgba(0,0,0,0.08)`,borderTopColor:P.blue,animation:'tm-spin .75s linear infinite'}}/>
                        </div>
                      ) : memberHistory[member.id]?.length > 0 ? (
                        <div style={{display:'flex',flexDirection:'column',gap:8,maxHeight:160,overflowY:'auto'}}>
                          {memberHistory[member.id].map(entry => (
                            <div key={entry.id} style={{display:'flex',gap:9,alignItems:'flex-start'}}>
                              <div className="tm-history-dot"/>
                              <div style={{flex:1}}>
                                <p style={{fontSize:12,color:P.dark,margin:0,lineHeight:1.4}}>{entry.description}</p>
                                <p style={{fontSize:11,color:P.gray,margin:'1px 0 0'}}>{entry.relative_time}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p style={{fontSize:12,color:P.gray,textAlign:'center',margin:'8px 0',padding:'8px 0'}}>
                          {t('teams.activity.noChanges', `Sin cambios en los últimos ${historyDaysFilter} días`).replace('{days}', historyDaysFilter)}
                        </p>
                      )}
                    </div>

                    {/* Access key */}
                    <div style={{paddingTop:12,borderTop:'1px solid rgba(0,0,0,0.07)'}}>
                      <span style={{fontSize:12,fontWeight:600,color:P.dark,letterSpacing:'-0.01em',display:'block',marginBottom:8}}>{t('teams.accessKey.title', 'Llave de acceso')}</span>
                      {member.has_access_key ? (
                        <div style={{display:'flex',flexDirection:'column',gap:6}}>
                          <div style={{display:'flex',gap:6}}>
                            <button
                              className="tm-btn tm-btn-blue tm-btn-sm"
                              style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',gap:5}}
                              onClick={() => handleRegenerateKey(member.id)}
                            >
                              <IconRefresh /> {t('teams.accessKey.regenerate', 'Regenerar')}
                            </button>
                            <button
                              className={`tm-btn tm-btn-sm ${member.access_key_active ? 'tm-btn-danger' : 'tm-btn-ghost'}`}
                              style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',gap:5}}
                              onClick={() => handleToggleKey(member.id, member.access_key_active, member.name)}
                            >
                              <IconLock open={member.access_key_active} />
                              {member.access_key_active ? t('teams.accessKey.deactivate', 'Desactivar') : t('teams.accessKey.activate', 'Activar')}
                            </button>
                          </div>
                          {member.invited_email && (
                            <p className="tm-invited-pill">{t('teams.invite.invitedLabel', `Invitado: ${member.invited_email}`).replace('{email}', member.invited_email)}</p>
                          )}
                        </div>
                      ) : (
                        <button
                          className="tm-btn tm-btn-blue tm-btn-sm"
                          style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'center',gap:6}}
                          onClick={() => handleGenerateKey(member.id)}
                        >
                          <IconKey /> {t('teams.accessKey.generate', 'Generar llave')}
                        </button>
                      )}

                      {/* Invite by email — replaces manual key copy as the primary onboarding path */}
                      <div className="tm-invite-row">
                        <input
                          className="tm-invite-input"
                          type="email"
                          placeholder={t('teams.invite.placeholder', 'correo@empresa.com')}
                          value={inviteDrafts[member.id] ?? member.email ?? ''}
                          onChange={e => setInviteDrafts(prev => ({ ...prev, [member.id]: e.target.value }))}
                        />
                        <button
                          className="tm-btn tm-btn-blue tm-btn-sm"
                          style={{display:'flex',alignItems:'center',gap:5,whiteSpace:'nowrap'}}
                          disabled={invitingMember === member.id}
                          onClick={() => handleInviteMember(member.id)}
                        >
                          <IconMail /> {invitingMember === member.id ? t('teams.invite.sending', 'Enviando…') : t('teams.invite.send', 'Invitar')}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      </>
      )}

      {/* ── Key Modal ───────────────────────────────────────────── */}
      {showKeyModal && currentKey && (
        <div className="tm-modal-backdrop" onClick={e => e.target === e.currentTarget && setShowKeyModal(false)}>
          <div className="tm-modal">
            {/* Modal header */}
            <div style={{padding:'22px 24px 0',borderBottom:'1px solid rgba(0,0,0,0.07)',paddingBottom:16}}>
              <div style={{display:'flex',alignItems:'center',gap:10}}>
                <div style={{width:36,height:36,borderRadius:10,background:'#F5F5F5',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  <IconKey />
                </div>
                <div>
                  <h2 style={{fontSize:16,fontWeight:700,color:P.dark,letterSpacing:'-0.025em',margin:0}}>{t('teams.keyModal.title', 'Llave de Acceso')}</h2>
                  <p style={{fontSize:12,color:P.gray,margin:'2px 0 0'}}>{currentKey.profile_name}</p>
                </div>
              </div>
            </div>

            {/* Modal body */}
            <div style={{padding:'18px 24px',display:'flex',flexDirection:'column',gap:14}}>
              {/* Warning */}
              <div className="tm-warning">
                <p style={{fontSize:12.5,color:'#92400E',margin:0,fontWeight:500,lineHeight:1.4}}>
                  {t('teams.keyModal.warning', 'Guarda esta llave de forma segura. No podrás verla nuevamente una vez que cierres esta ventana.')}
                </p>
              </div>

              {/* Key display */}
              <div className="tm-key-box">{currentKey.access_key}</div>

              {/* Actions */}
              <button
                className="tm-btn tm-btn-blue"
                style={{display:'flex',alignItems:'center',justifyContent:'center',gap:7,width:'100%'}}
                onClick={handleCopyKey}
              >
                <IconCopy />
                {copied ? t('teams.keyModal.copied', 'Copiado') : t('teams.keyModal.copy', 'Copiar llave')}
              </button>

              <p style={{fontSize:12,color:P.gray,margin:0,textAlign:'center',lineHeight:1.4}}>
                {t('teams.keyModal.desc', 'Esta llave otorga acceso exclusivo al perfil a través de "Contact for Teams"')}
              </p>
            </div>

            {/* Modal footer */}
            <div style={{padding:'0 24px 20px'}}>
              <button
                className="tm-btn tm-btn-ghost"
                style={{width:'100%'}}
                onClick={() => { setShowKeyModal(false); setCurrentKey(null); }}
              >
                {t('teams.keyModal.close', 'Cerrar')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamsPanel;
